// An image's size in pixels, as the browser decodes it: a file about to be uploaded, or an image already loaded on the
// page. Undefined when the browser can't read it, or hasn't within timeoutMs (an upload goes ahead without it).
export function readImageSize(file: Blob, timeoutMs = 5000): Promise<{ width: number, height: number } | undefined> {
    return new Promise(resolve => {
        const url = URL.createObjectURL(file);
        const image = new Image();
        const timer = setTimeout(() => done(undefined), timeoutMs);
        const done = (size?: { width: number, height: number }) => {
            clearTimeout(timer);
            URL.revokeObjectURL(url);
            resolve(size);
        };
        image.onload = () => done(sizeOf(image));
        image.onerror = () => done(undefined);
        image.src = url;
    });
}

export function sizeOf(image: HTMLImageElement): { width: number, height: number } | undefined {
    return image.naturalWidth > 0 && image.naturalHeight > 0 ? { width: image.naturalWidth, height: image.naturalHeight } : undefined;
}

// An image's width and height attributes, when its size is known: the browser then keeps its place, in its shape,
// before it has loaded (CSS still sizes it), so the page doesn't jump.
export const sizeAttributes = (image: { width?: number, height?: number }) =>
    image.width && image.height ? { width: image.width, height: image.height } : {};
